
import * as TimeTableConstants from './TimeTableConstants'

let initialState = {
    timeTableData: {},
    getTimeTableInProgress: false,
    getTimeTableComplete: false,
    getTimeTableFailed: false,

}



const createSchoolInformationReducer = (state = initialState, action) => {
    switch (action.type) {
        
        case TimeTableConstants.GET_TIME_TABLE_IN_PROGRESS:
            return { ...state, getTimeTableInProgress: true, timeTableData:{},getTimeTableFailed: false, getTimeTableComplete: false };
        case TimeTableConstants.GET_TIME_TABLE_COMPLETE:
            
            return { ...state, getTimeTableInProgress: false, getTimeTableFailed: false, getTimeTableComplete: true, timeTableData: action.data };
        case TimeTableConstants.GET_TIME_TABLE_FAILED:
            return { ...state, getTimeTableInProgress: false, timeTableData:{}, getTimeTableComplete: false,getTimeTableFailed: true };
        
        default:
            return state;
    }


}
export default createSchoolInformationReducer;